import {
  LayoutDashboard,
  Users,
  FileText,
  BarChart3,
  Settings,
  FormInput,
  Wallet,
  ListChecks,
  Boxes,
  Package,
  CheckSquare,
  Hash,
  Webhook,
} from "lucide-react"
import type { NavGroup, NavItem } from "./nav-types"

export const NAV_GROUPS: NavGroup[] = [
  {
    label: "Pulpit",
    items: [
      {
        label: "Dashboard",
        path: "/",
        icon: LayoutDashboard,
        description: "Przegląd kluczowych wskaźników i szybki dostęp",
        enabled: true,
      },
    ],
  },
  {
    label: "Sprzedaż",
    items: [
      {
        label: "Klienci",
        path: "/clients",
        icon: Users,
        description: "Baza klientów, kontakty, historia współpracy",
        enabled: true,
      },
      {
        label: "Umowy",
        path: "/contracts",
        icon: FileText,
        description: "Umowy, statusy, workflow akceptacji",
        enabled: true,
      },
      {
        label: "Zadania",
        path: "/tasks",
        icon: CheckSquare,
        description: "Twój kanban - osobisty board zadań",
        enabled: true,
      },
    ],
  },
  {
    label: "Analityka",
    items: [
      {
        label: "Raporty",
        path: "/reports",
        icon: BarChart3,
        description: "Raporty sprzedażowe, eksporty, dashboardy ad-hoc",
        enabled: false,
      },
    ],
  },
  {
    label: "Ustawienia",
    items: [
      {
        label: "Konfiguracje umów",
        path: "/settings/configurations",
        icon: Boxes,
        description: "Konfiguracje umów (PV, Pompa ciepła, ...) - każda ma swoje etapy, formularz, statusy",
        enabled: true,
      },
      {
        label: "Produkty (elementy)",
        path: "/settings/products",
        icon: Package,
        description: "Elementy umowy (fotowoltaika, magazyn, wiatrak...) - każdy ma własne etapy",
        enabled: true,
      },
      {
        label: "Sekcje formularzy",
        path: "/settings/forms",
        icon: FormInput,
        description: "Definicja sekcji i pól - umowy i aneksy",
        enabled: true,
      },
      {
        label: "Słowniki",
        path: "/settings/dictionaries",
        icon: Wallet,
        description: "Typy płatności, źródła, typy akcji i typy dokumentów zadań",
        enabled: true,
      },
      {
        label: "Tory statusów",
        path: "/settings/status-tracks",
        icon: ListChecks,
        description: "Równoległe tory (Kredyty, Logistyka, ...) i ich wartości",
        enabled: true,
      },
      {
        label: "Role i widzialność",
        path: "/admin/roles",
        icon: Settings,
        description: "Kto co może (uprawnienia) i kto co widzi (reguły widzialności)",
        enabled: true,
      },
      {
        label: "Zespoły",
        path: "/admin/teams",
        icon: Users,
        description: "Hierarchiczna struktura organizacji + członkostwo użytkowników",
        enabled: true,
      },
      {
        label: "Użytkownicy",
        path: "/admin/users",
        icon: Users,
        description: "Lista użytkowników z HaloCRM + nadawanie ról",
        enabled: true,
      },
      {
        label: "Regiony - handlowcy",
        path: "/admin/regions",
        icon: Users,
        description: "Przypisanie handlowców do regionów (oddziałów)",
        enabled: true,
      },
      {
        label: "Numeracja dokumentów",
        path: "/admin/numbering",
        icon: Hash,
        description: "Schematy numeracji umów, faktur, aneksów",
        enabled: true,
      },
      {
        label: "Integracje",
        path: "/admin/integrations",
        icon: Webhook,
        description: "Źródła webhooków, CORS origins, historia zdarzeń",
        enabled: true,
      },
      {
        label: "Administracja",
        path: "/admin",
        icon: Settings,
        description: "Sync użytkowników, audit log",
        enabled: true,
      },
    ],
  },
]

export const ALL_NAV_ITEMS: NavItem[] = NAV_GROUPS.flatMap((g) => g.items)

export function findNavItemByPath(pathname: string): NavItem | undefined {
  if (pathname === "/") return ALL_NAV_ITEMS.find((i) => i.path === "/")
  return ALL_NAV_ITEMS.find((i) => i.path !== "/" && pathname.startsWith(i.path))
}
